
webpack.register(
    'components/image-universal/image-universal',
    function() {
        return require('components/image-universal/image-universal');
    },
    false
);
var stache = require('can/view/stache/stache');
module.exports = stache("<can-import from='components/image-universal/image-universal'/>\r\n<div class=\"c-sponsor\">\r\n    {{#if sponsor}}\r\n        <div class=\"s-head-sponsor\">\r\n            <a {{#if sponsor.link.url}}href=\"{{sponsor.link.url}}\"{{/if}} class=\"s-head-sponsor__link\">\r\n                {{title}}\r\n                <image-universal {class-name}=\"'s-head-sponsor__img'\" {image}=\"image\" {crop}=\"'fit'\"/>\r\n            </a>\r\n        </div>\r\n    {{/if}}\r\n</div>");